"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBillVendorsRequest = exports.transformBillVendorsParsedResponse = exports.transformBillVendorsListResponse = exports.transformBillVendorsResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Error_1 = require("./Error");
const Money_1 = require("./Money");
const Date_1 = require("./Date");
const BillVendorTax_1 = require("./BillVendorTax");
function transformBillVendorsResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { bill_vendor } = response.response.result;
    return transformBillVendorsParsedResponse(bill_vendor);
}
exports.transformBillVendorsResponse = transformBillVendorsResponse;
function transformBillVendorsListResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { bill_vendors, per_page, total, page, pages } = response.response.result;
    return {
        bill_vendors: bill_vendors.map((vendor) => transformBillVendorsParsedResponse(vendor)),
        pages: {
            total,
            size: per_page,
            pages,
            page,
        },
    };
}
exports.transformBillVendorsListResponse = transformBillVendorsListResponse;
function transformBillVendorsParsedResponse(vendor) {
    return {
        accountNumber: vendor.account_number,
        city: vendor.city,
        country: vendor.country,
        currencyCode: vendor.currency_code,
        is1099: vendor.is_1099,
        language: vendor.language,
        note: vendor.note,
        outstandingBalance: vendor.outstanding_balance &&
            vendor.outstanding_balance.map((balance) => (0, Money_1.transformMoneyParsedResponse)(balance)),
        overdueBalance: vendor.overdue_balance &&
            vendor.overdue_balance.map((balance) => (0, Money_1.transformMoneyParsedResponse)(balance)),
        phone: vendor.phone,
        postalCode: vendor.postal_code,
        primaryContactEmail: vendor.primary_contact_email,
        primaryContactFirstName: vendor.primary_contact_first_name,
        primaryContactLastName: vendor.primary_contact_last_name,
        province: vendor.province,
        street: vendor.street,
        street2: vendor.street2,
        taxDefaults: vendor.tax_defaults &&
            vendor.tax_defaults.map((tax) => (0, BillVendorTax_1.transformBillVendorTaxParsedResponse)(tax)),
        vendorId: vendor.vendorid,
        visState: vendor.vis_state,
        website: vendor.website,
        vendorName: vendor.vendor_name,
        createdAt: vendor.created_at && (0, Date_1.transformDateResponse)(vendor.created_at, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
        updatedAt: vendor.updated_at && (0, Date_1.transformDateResponse)(vendor.updated_at, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
    };
}
exports.transformBillVendorsParsedResponse = transformBillVendorsParsedResponse;
function transformBillVendorsRequest(vendor) {
    return JSON.stringify({
        bill_vendor: {
            account_number: vendor.accountNumber,
            city: vendor.city,
            country: vendor.country,
            currency_code: vendor.currencyCode,
            is_1099: vendor.is1099,
            language: vendor.language,
            note: vendor.note,
            phone: vendor.phone,
            postal_code: vendor.postalCode,
            primary_contact_email: vendor.primaryContactEmail,
            primary_contact_first_name: vendor.primaryContactFirstName,
            primary_contact_last_name: vendor.primaryContactLastName,
            province: vendor.province,
            street: vendor.street,
            street2: vendor.street2,
            tax_defaults: vendor.taxDefaults &&
                vendor.taxDefaults.map((tax) => (0, BillVendorTax_1.transformBillVendorTaxParsedRequest)(tax)),
            vendorid: vendor.vendorId,
            vis_state: vendor.visState,
            website: vendor.website,
            vendor_name: vendor.vendorName,
        },
    });
}
exports.transformBillVendorsRequest = transformBillVendorsRequest;
//# sourceMappingURL=BillVendors.js.map